var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeiconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 21.5,
    fill: "#60C8DD",
    stroke: "#60C8DD",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24.7475 30.7492V24.7492H20.2475V30.7492L14.248 30.75V21.3317C14.248 21.2272 14.2699 21.1239 14.3121 21.0283C14.3544 20.9328 14.4162 20.8471 14.4935 20.7768L21.993 13.9579C22.131 13.8324 22.3109 13.7628 22.4975 13.7628C22.6841 13.7628 22.864 13.8324 23.002 13.9579L30.5026 20.7768C30.5799 20.8471 30.6417 20.9328 30.6839 21.0283C30.7262 21.1239 30.748 21.2272 30.748 21.3317V30.75L24.7475 30.7492Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.748 30.75V21.3317C30.748 21.2272 30.7262 21.1239 30.6839 21.0283C30.6417 20.9328 30.5799 20.8471 30.5026 20.7768L23.002 13.9579C22.864 13.8324 22.6841 13.7628 22.4975 13.7628C22.3109 13.7628 22.131 13.8324 21.993 13.9579L14.4935 20.7768C14.4162 20.8471 14.3544 20.9328 14.3121 21.0283C14.2699 21.1239 14.248 21.2272 14.248 21.3317V30.75",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.998 30.75H32.998",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7461 30.7493V24.7493H20.2461V30.7493",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeiconActive);
export default __webpack_public_path__ + "static/media/HomeiconActive.87bced4a0daa32c4897e6cb44703fb93.svg";
export { ForwardRef as ReactComponent };